export default {
    consumptionCenters: [],
    currentConsumptionCenter: null,
    countryCodes: []
}